import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from './interface';

@Injectable({
  providedIn: 'root'
})
export class CourtService {

  constructor(
    private http : HttpClient
  ) { }

  getCourts(status){
    let params : HttpParams = new HttpParams().set('active', status);
    return this.http.get<response>(environment.url + "courts", {params : params});
  }

  getCourt(id){
    let params : HttpParams = new HttpParams().set('id', id);
    return this.http.get<response>(environment.url + "court", {params : params});
  }

  saveCourt(court){
    return this.http.post<response>(environment.url + "courts", court);
  }

  updateCourt(id, court){
    return this.http.put<response>(environment.url + "courts/"+id, court);
  }

  
}
